import React, { useEffect, Suspense } from "react";
import { ToastContainer } from "react-toastify";
import Layout from "./components/layout/Layout.jsx";
import { Route, Routes } from "react-router-dom";
import Providers from "./components/providers/Providers.jsx";
import ProviderDetails from "./components/providers/ProviderDetails.jsx";
import ProviderProfile from "./components/providers/ProviderProfile/ProviderProfile.jsx";
import {
  hideIntercomChatLauncher,
  showIntercomChatWidget,
} from "../../util/intercom";
import TreatmentPlan from "./components/TreatmentPlan/treatmentPlan.jsx";
import UnifiedOrhtocheck from "./components/unifiedOrthocheck/unifiedOrthocheck.jsx";
import { brand } from "../../config/brands";
const LandingPageApp = () => {
  const isDev =
    window.location.hostname === "localhost" ||
    window.location.hostname ===
      `dev-${brand.shortName.toLowerCase()}-web.${brand.domain}`;

  useEffect(() => {
    if (isDev) {
      hideIntercomChatLauncher();
    } else {
      showIntercomChatWidget();
    }
  }, [isDev]);

  function RedirectToExternal() {
    useEffect(() => {
      if (isDev) {
        window.location.href = "/providers";
      } else {
        window.location.href = `https://${brand.domain}/`;
      }
    }, []);

    return null;
  }

  return (
    <Suspense fallback={<Layout></Layout>}>
      <ToastContainer />
      <Routes>
        <Route path="/" element={<RedirectToExternal />} />
        <Route path="/providerprofile/:npiId" element={<ProviderProfile />} />
        <Route path="/treatmentplan/:session" element={<TreatmentPlan />} />
        <Route path="/orthocheck" element={<UnifiedOrhtocheck />} />
        <Route path="/orthocheck/unified" element={<UnifiedOrhtocheck />} />
        <Route path="/dentalcheck" element={<UnifiedOrhtocheck />} />
        <Route
          path="/:speciality/:lastName/:npiId"
          element={<ProviderProfile />}
        />
        <Route
          path="/:speciality/practice/:npiId/:practiceLocationGroupId"
          element={<ProviderProfile />}
        />
        <Route path="/providers/:id" element={<ProviderDetails />} />
        <Route path="/providers" element={<Providers />} />
        <Route
          path="*"
          element={
            <iframe
              src="/404.html"
              title="404 Page"
              style={{
                width: "100%",
                height: "100vh",
                border: "none",
                overflow: "hidden",
              }}
              scrolling="no"
            />
          }
        />
        <Route
          path="*"
          element={
            <iframe
              src="/404.html"
              title="404 Page"
              style={{
                width: "100%",
                height: "100vh",
                border: "none",
                overflow: "hidden",
              }}
              scrolling="no"
            />
          }
        />
      </Routes>
    </Suspense>
  );
};

export default LandingPageApp;
